<template>
  <div v-loading="loading" element-loading-text="数据加载中，请稍后..." element-loading-spinner="el-icon-loading" class="course-apply-detail-form">
    <!-- <page-header :title="pageTitle" :data="pageHeaderArr" @back="goBack" /> -->
    <div class="my-page-head">
      <el-page-header :content="pageTitle" @back="goBack" />
      <ul class="page-head-ul">
        <li v-for="(item, index) in pageHeaderArr" :key="item.title + index">
          <label>{{ item.title }}:</label>
          <span>{{ item.value }}</span>
        </li>
      </ul>
    </div>

    <el-descriptions title="调课信息" style="margin-top: 20px">
      <el-descriptions-item label="审核状态">{{ FormData.auditStateText }}</el-descriptions-item>
      <el-descriptions-item label="申请时间">{{ FormData.applyTime }}</el-descriptions-item>
      <el-descriptions-item :label="FormData.auditState == -1 ? '撤销时间' : '审核时间'">{{ FormData.auditTime || '--' }}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="用户信息" style="margin-top: 20px">
      <el-descriptions-item label="姓名">{{ userInfo.name }}</el-descriptions-item>
      <el-descriptions-item label="学号">{{ userInfo.idnumber }}</el-descriptions-item>
      <el-descriptions-item label="班级">{{ userInfo.idnumber }}</el-descriptions-item>

      <el-descriptions-item label="手机">{{ FormData.phone }}</el-descriptions-item>
    </el-descriptions>
    <!-- 缓修，缓考、免修不免考、免修免考 -->
    <!-- 1、3、6、7 -->
    <div v-if="[1, 3, 6, 7].includes(applyType)">
      <el-descriptions title="相关证明" style="margin-top: 20px">
        <el-descriptions-item v-if="+FormData.evidenceType === 1" label="证明人">{{ FormData.evidenceName }}</el-descriptions-item>
        <el-descriptions-item v-if="+FormData.evidenceType === 1" label="证明电话">{{ FormData.evidencePhone }}</el-descriptions-item>
        <el-descriptions-item v-if="+FormData.evidenceType === 2" label="证明文件">
          <el-link :href="FormData.evidenceFile" target="_blank" type="primary">查看附件</el-link>
          <!-- <ming-image :src="FormData.evidenceFile" width="160px" height="90px" fit="cover" style="border-radius: 3px; overflow: hidden;" /> -->
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <!-- <el-descriptions v-if="[1, 3, 6, 7].includes(applyType)" title="相关证明" style="margin-top: 20px;">
      <el-descriptions-item label="证明人">{{ FormData.evidenceName }}</el-descriptions-item>
      <el-descriptions-item label="证明电话">{{ FormData.evidencePhone }}</el-descriptions-item>
    </el-descriptions> -->
    <!-- applyCourseInfo: {{ FormData.applyCourseInfo }} -->
    <el-descriptions :title="[5].includes(applyType) ? '原课程调整申请单' : '课程情况'" style="margin-top: 20px">
      <el-descriptions-item v-if="[2, 4, 5].includes(applyType)" label="申请单号">
        {{ FormData.applyNumber }}
      </el-descriptions-item>
      <el-descriptions-item label="课程名称">
        {{ FormData.applyCourseInfo ? FormData.applyCourseInfo.courseNameZh : '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="课程编号">
        {{ FormData.applyCourseInfo.courseCode }}
      </el-descriptions-item>
      <el-descriptions-item label="课程变动类型">
        {{ FormData.applyTypeText }}
      </el-descriptions-item>
      <el-descriptions-item label="提交时间">
        {{ FormData.applyTime }}
      </el-descriptions-item>
      <el-descriptions-item label="学年">
        {{ FormData.applyCourseInfo.courseSchoolYear }}
      </el-descriptions-item>
      <el-descriptions-item label="学期">
        {{ FormData.applyCourseInfo.courseSemester }}
      </el-descriptions-item>
      <el-descriptions-item label="考试时间">
        {{ FormData.applyCourseInfo.courseExamTime }}
      </el-descriptions-item>
      <el-descriptions-item label="考试地点">
        {{ FormData.applyCourseInfo.courseExamPlace }}
      </el-descriptions-item>
      <el-descriptions-item v-if="+applyType===2" label="成绩">
        {{ FormData.applyCourseInfo.levelScore }}
      </el-descriptions-item>
      <!--  -->
    </el-descriptions>
    <!-- 再考、缓修在修、重修 -->
    <!-- 2、4、5 -->
    <!-- targetCourseInfo: {{ FormData.targetCourseInfo }},,, -->
    <el-descriptions v-if="[2, 4, 5].includes(applyType)" title="目标课程" style="margin-top: 20px">
      <el-descriptions-item label="课程名称">
        {{ FormData.applyCourseInfo ? FormData.targetCourseInfo.courseNameZh : '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="课程编号">
        {{ FormData.targetCourseInfo.courseCode }}
      </el-descriptions-item>
      <el-descriptions-item label="课程性质">
        {{ FormData.targetCourseInfo.courseNature }}
      </el-descriptions-item>
      <el-descriptions-item label="讲课教师">
        {{ FormData.targetCourseInfo.courseTeacher }}
      </el-descriptions-item>
      <el-descriptions-item label="上课班级">
        {{ FormData.targetCourseInfo.courseClass }}
      </el-descriptions-item>
      <el-descriptions-item label="学年">
        {{ FormData.targetCourseInfo.courseSchoolYear }}
      </el-descriptions-item>
      <el-descriptions-item label="学期">
        {{ FormData.targetCourseInfo.courseSemester }}
      </el-descriptions-item>
      <el-descriptions-item label="学分">
        {{ FormData.targetCourseInfo.courseCredit }}
      </el-descriptions-item>
      <el-descriptions-item label="学时">
        {{ FormData.targetCourseInfo.courseClassHour }}
      </el-descriptions-item>
      <el-descriptions-item label="考试时间">
        {{ FormData.targetCourseInfo.courseExamTime }}
      </el-descriptions-item>
      <el-descriptions-item label="考试地点">
        {{ FormData.targetCourseInfo.courseExamPlace }}
      </el-descriptions-item>
    </el-descriptions>
    <!-- 申请原因 -->
    <el-descriptions direction="vertical">
      <el-descriptions-item label="申请原因">
        <span style="white-space: pre-line">
          {{ FormData.applyReason }}
        </span>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import Store from '@/store'

// import { returnFullPath } from '@/utils/index'
// import MingImage from '@/components/MingImage'
import { courseApplyHook } from '@/hooks/courseApplyFormHook'
import Router from '@/router'
const { loading, GetCourseChangeApplyDetail } = courseApplyHook()

const userInfo = computed(() => {
  return Store.state.user.userInfo
})
const graduationDate = computed(() => {
  return Store.state.user.graduationDate
})
const pageTitle = ref('申请单')
// 返回
function goBack() {
  Router.go(-1)
}
const pageHeaderArr = ref([
  {
    title: '学号',
    value: userInfo.value.idnumber || '-'
  },
  {
    title: ' 班级',
    value: userInfo.value.className || '-'
  },
  {
    title: ' 预计毕业日期',
    value: graduationDate.value || '-'
  }
])
const applyType = ref(null)
const FormData = ref({
  applyCourseInfo: {
    courseClass: '',
    courseClassHour: '',
    courseCode: '',
    courseCredit: '',
    courseExamPlace: '',
    courseExamTime: '',
    courseNameZh: '',
    courseNature: '',
    courseSchoolYear: '',
    courseSemester: '',
    courseTeacher: ''
  },
  targetCourseInfo: {
    courseClass: '',
    courseClassHour: '',
    courseCode: '',
    courseCredit: '',
    courseExamPlace: '',
    courseExamTime: '',
    courseNameZh: '',
    courseNature: '',
    courseSchoolYear: '',
    courseSemester: '',
    courseTeacher: ''
  }
})

onMounted(() => {
  GetCourseChangeApplyDetail().then(res => {
    FormData.value = res
    pageTitle.value = res.applyTypeText + '申请单详情'
    applyType.value = res.applyType
  })
})
</script>

<style lang="scss" scoped>
.my-page-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 20px;
}
ul.page-head-ul {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0;
  padding: 0;
  li {
    list-style: none;
    label {
      font-size: 16px;
      color: #777;
      margin-right: 10px;
    }
    span {
      font-size: 16px;
      color: #333;
    }
    &:not(:last-child) {
      margin-right: 60px;
    }
  }
}
</style>
